import { plainToInstance } from 'class-transformer';
import { Dispatch, Ref, SetStateAction } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { ManagerDTO } from '../../commons/dtos/manager.dto';
import { IManagerRequest } from '../../commons/interfaces/manager.interface';
import { ModalSizeType } from '../../components/CustomModal';
import { ActionType } from '../../components/CustomTable/interfaces';
import './style.scss';

interface ManagerFormProps {
  currentManager: IManagerRequest;
  setCurrentManager: Dispatch<SetStateAction<IManagerRequest>>;
  formRef: Ref<HTMLFormElement>;
  validated: boolean;
  actionType: ActionType;
  changeSize?: (size: ModalSizeType) => void;
}

const ManagerForm = (props: ManagerFormProps) => {
  const { currentManager, setCurrentManager, formRef, validated, actionType, changeSize } = props;
  const savedDisplayedRole = currentManager.displayedRole;
  const isDelete = actionType === 'DELETE';
  const canShowExtraInfo =
    savedDisplayedRole === 'Administrador' && currentManager.role === 'MANAGER';

  // Transforma un obejct a dto y lo setea al currentManager
  const setManagarDto = (newManagger: IManagerRequest) => {
    const newManagerDto = plainToInstance(ManagerDTO, newManagger);
    const newCurrentManager: IManagerRequest = {
      ...newManagerDto,
      status: newManagerDto.status,
      displayedRole: savedDisplayedRole
    };

    setCurrentManager(newCurrentManager);
  };

  // Crear un object con la nueva informacion del manager para inputes y selects
  const handleChange = (ev: any, currentManagerKey: string) => {
    const newCurrentManager = { ...currentManager, [currentManagerKey]: ev.target.value };
    setManagarDto(newCurrentManager);
  };

  // Crear un object del manager para checks
  const handleCheckChange = (ev: any) => {
    const newCurrentManager = { ...currentManager, withNotification: ev.target.checked };
    setManagarDto(newCurrentManager);
  };

  // Crea un object del manager para status
  const handleStatusChange = (ev: any) => {
    const changedValue = ev.target.value;
    const isBlocked = changedValue === 'Bloqueado';
    const newCurrentManager = { ...currentManager, isBlocked, status: changedValue };

    setManagarDto(newCurrentManager);
  };

  const handleRoleChange = (ev: any) => {
    const newValue = ev.target.value;
    const newCurrentManager = { ...currentManager, role: newValue };

    if (newValue === 'MANAGER' && savedDisplayedRole === 'Administrador') {
      changeSize?.('lg');
    } else {
      changeSize?.(undefined);
    }

    setManagarDto(newCurrentManager);
  };

  if (isDelete) {
    return (
      <div>
        <span>
          Estas a punto de eliminar este usuario "{currentManager.name}",{' '}
          <strong>esta acción no puede ser revertida.</strong>
        </span>
        <br />
        <br />
        <span>¿Seguro que deseas realizar esta acción?</span>
      </div>
    );
  }

  return (
    <Form ref={formRef} noValidate validated={validated}>
      <Row>
        <Col>
          <Form.Group className="form-group">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              value={currentManager.name || ''}
              onChange={(ev) => handleChange(ev, 'name')}
              required
            />
            <Form.Control.Feedback type="invalid">Nombre es requerido</Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label>Correo electrónico</Form.Label>
            <Form.Control
              type="email"
              value={currentManager.email || ''}
              onChange={(ev) => handleChange(ev, 'email')}
              disabled={actionType === 'EDIT'}
              required
            />
            <Form.Control.Feedback type="invalid">
              Correo electrónico es requerido
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label>Permiso</Form.Label>
            <Form.Control
              as={Form.Select}
              value={currentManager.role}
              onChange={handleRoleChange}
              // disabled={currentManager.displayedRole === 'Usuario'}
              required>
              <option value="ADMIN">Administrador</option>
              <option value="MANAGER">Usuario</option>
            </Form.Control>
          </Form.Group>

          {canShowExtraInfo && (
            <Form.Group className="form-group">
              <Form.Label>Correo electrónico administrador</Form.Label>
              <Form.Control
                type="email"
                value={currentManager.newAdminEmail || ''}
                onChange={(ev) => handleChange(ev, 'newAdminEmail')}
                required
              />
              <Form.Control.Feedback type="invalid">
                Correo electrónico es requerido
              </Form.Control.Feedback>
            </Form.Group>
          )}
          {actionType === 'EDIT' && (
            <Form.Group className="form-group">
              <Form.Label>Estado</Form.Label>
              <Form.Control
                as={Form.Select}
                value={currentManager.status}
                onChange={handleStatusChange}
                disabled={savedDisplayedRole === 'Administrador'}
                required>
                <option value="Activo">Activo</option>
                <option value="Bloqueado">Bloqueado</option>
              </Form.Control>
            </Form.Group>
          )}
          {!currentManager.id && (
            <Form.Group className="form-group">
              <Form.Check
                label="Enviar correo electrónico al nuevo usuario"
                value={currentManager.withNotification ? 'yes' : 'no'}
                onChange={handleCheckChange}
              />
            </Form.Group>
          )}
        </Col>
        {canShowExtraInfo && (
          <Col className="align-self-center">
            <h5 className="text-important">Importante!!</h5>
            <span>
              Recuerda que si sedes tu cargo administrativo a otro usuario el sistema te redigira a
              otra sección y ya no tendras acceso a la sección de Gestión de usuarios
            </span>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default ManagerForm;
